import script from "./period-selection-info.vue?vue&type=script&setup=true&lang=ts"
export * from "./period-selection-info.vue?vue&type=script&setup=true&lang=ts"

import "./period-selection-info.vue?vue&type=style&index=0&id=8880cd06&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8880cd06"]])

export default __exports__